<template>
  <div
    id="debug-auth"
  >
    <h3
      class="text-center"
    >
      Debug User Authentication
    </h3>

    <hr />

    <user-nav
      :userId="userId"
    />

    <p
      class="alert alert-danger text-center"
    >
      This is meant to debug user accounts that should be able to access the Admin CMS, but cannot.
      <br />
      Do not use this to debug standard user accounts.
    </p>

    <h4>User Credentials</h4>

    <div
      class="form-group"
      v-if="hasResults"
    >
      <ul class="list-group">
        <li class="list-group-item">test</li>
      </ul>
    </div>

    <form
      v-on:submit.prevent="debugCreds"
    >
      <div
        class="form-group"
      >
        <label
          for="user_email"
        >
          Email Address
        </label>

        <input
          type="email"
          class="form-control"
          id="user_email"
          placeholder="Enter Email"
          v-model="email"
          required
        />
      </div>
      <div
        class="form-group"
      >
        <label
          class="d-block"
          for="user_password"
        >
          Password
          <a
            href=""
            class="float-right"
            v-on:click.prevent="toggleShowPassword"
          >
            {{ passwordShowStr }}
          </a>
        </label>

        <input
          :type="passwordType"
          class="form-control"
          id="user_password"
          placeholder="Enter Password"
          v-model="password"
          required
        >
      </div>
      <div
        class="form-group"
      >
        <button
          type="submit"
          class="btn btn-primary btn-block"
        >
          Debug

          <spinner
            size="small"
            v-if="loaders.debugUserAuth"
          />
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import Spinner from 'vue-simple-spinner'

import UserNav from '@/components/UserNav'

import PasswordMixin from '@/mixins/PasswordMixin'

import { mapState } from 'vuex'

export default {
  props: {
    userId: {
      type: [ Number, String ],
      default: undefined
    }
  },

  data () {
    return {
      email: undefined,
      hasResults: false,
      password: undefined,
      token: undefined
    }
  },

  components: {
    'spinner': Spinner,
    'user-nav': UserNav
  },

  computed: mapState({
    loaders: state => state.LoaderModule.loaders,
    user: state => state.UserModule.user
  }),

  mixins: [
    PasswordMixin
  ],

  methods: {
    debugCreds () {
      this.hasResults = false
      this.$store.dispatch(
        `UserModule/debugUserAuth`, {
          username: this.email,
          password: this.password
        }
      ).then((results) => {
        this.hasResults = true
      }).catch(this.$root.processErrors)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DebugAuth.vue